function NotificationBell({ notifications = 0, unreads = false}) {
  return (
    <span>
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="30" viewBox="-8 -12 40 30">
      	<path
          fill="currentColor"
	        fillRule="evenodd"
          d="M14 12v1H0v-1l.73-.58c.77-.77.81-2.55 1.19-4.42C2.69 3.23 6 2 6 2c0-.55.45-1 1-1s1 .45 1 1c0 0 3.39 1.23 4.16 5 .38 1.88.42 3.66 1.19 4.42l.66.58H14zm-7 4c1.11 0 2-.89 2-2H5c0 1.11.89 2 2 2z"
        />
        {notifications
        ? (
          <g transform="translate(20)">
            <circle r="8.5" fill="none" stroke={unreads ? 'red' : 'currentColor'} strokeWidth="2">
              <title>{notifications} notifications</title>
            </circle>
            <text dy="4" textAnchor="middle" fill={unreads ? 'red' : 'currentColor'}>{notifications}</text>
          </g>
        )
        : undefined
        }
      </svg>
    </span>
  );
}

export default NotificationBell;